// extracted by mini-css-extract-plugin
export default {"description":"nM5D9","addNumberButton":"JtmBs","switchLink":"FTIDn","tableWrapper":"YY3FD","numberList":"hdi4m","settingsHeading":"hkDNy","help-links":"kLUVi"};